import {twMerge} from "libs/twmerge"
import * as React from "react"

/**
 * @typedef {'primary' | 'secondary'} TextButtonVariant
 */

/**
 * @typedef {object} TextButtonProps
 * @property {string} children
 * @property {string} [className]
 * @property {TextButtonVariant} [variant]
 */

const TextButton = React.forwardRef(
  (
    /** @type {TextButtonProps & import("react").ButtonHTMLAttributes<HTMLButtonElement>} */
    {children, variant = "primary", className = "", ...restProps},
    ref,
  ) => {
    return (
      <button
        className={twMerge(
          `
          flex min-h-[40px] items-center justify-center rounded-[24px]
          typo-v3-button py-3 no-underline
          hover:text-blue-primary disabled:text-gray-silver
          `,
          variantColorMap[variant],
          className,
        )}
        type="button"
        ref={ref}
        {...restProps}
      >
        {children}
      </button>
    )
  },
)

/**
 * @type {Record<TextButtonVariant, string>}
 */
const variantColorMap = {
  primary: "text-black",
  secondary: "text-dark",
}

export default TextButton
